import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import * as links from '../../lib/links';
import UIAlert from 'UIComponents/alert/UIAlert';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const PreviewAlert = ({
  deckId
}) => /*#__PURE__*/_jsx(UIAlert, {
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "view.previewAlert.title"
  }),
  type: "warning",
  children: /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "view.previewAlert.description",
    options: {
      documentSummaryLink: /*#__PURE__*/_jsx(Link, {
        href: links.getSummaryPageURL(deckId),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "view.previewAlert.documentSummaryLink"
        })
      })
    }
  })
});
export default PreviewAlert;